import { Injectable, Inject, InjectionToken } from "@angular/core";
import { ApiCallsService } from "icamppro-shared-components";

export const FEATURE_FLAGS_API_URL_STRING = new InjectionToken<string>('FEATURE_FLAGS_API_URL_STRING');

// Module-level constants avoid the ES2022 static class field temporal dead zone,
// where referencing the class name inside a static initializer results in undefined.
const FEATURE_POS_MODULE = 'Point of Sale Module' as const;
const FEATURE_FACILITY_RENTALS = 'Facility Rentals' as const;
const ALL_FEATURES = [FEATURE_POS_MODULE, FEATURE_FACILITY_RENTALS] as const;

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  public static readonly FEATURE_POS_MODULE = FEATURE_POS_MODULE;
  public static readonly FEATURE_FACILITY_RENTALS = FEATURE_FACILITY_RENTALS;
  public static readonly ALL_FEATURES = ALL_FEATURES;

  private featureFlags: string[] = [];
  private loadPromise: Promise<void> = Promise.resolve();
  private loaded = false;
  public get loadFeatureFlagsPromise(): Promise<void> {
    return this.loaded ? new Promise<void>((resolve) => { resolve(); }) : this.loadPromise;
  }

  public constructor(
    private apiService: ApiCallsService,
    @Inject(FEATURE_FLAGS_API_URL_STRING) private featureFlagsApiUrl: string,
  ) {
    // ctor

    // attempting to load the feature flags in the constructor will BREAK THINGS! DO NOT DO IT!!!
    // this is injected into the layout service which happens before the app does its shadow login validation and this will return a 403 before that login and break the shadow login process
  }

  public reload(): Promise<void> {
    this.loadPromise = this.loadFeatureFlags();
    return this.loadPromise;
  }

  public async reloadIfNeeded(forceReload: boolean = false): Promise<void> {
    if (!this.loaded || forceReload) {
      await this.reload();
    }
  }

  private async loadFeatureFlags(): Promise<void> {
    this.loaded = false;
    this.featureFlags = [];
    const response = await this.apiService.getAsync(this.featureFlagsApiUrl);
    if (response && response.data && Array.isArray(response.data)) {
      this.setFeatureFlags(response.data);
    }
    this.loaded = true;
  }

  public setFeatureFlags(featureFlags: unknown[], setLoaded: boolean = false): void {
    this.featureFlags = featureFlags.map((featureFlag: unknown) =>  {
        return String(featureFlag);
    });
    this.loaded = setLoaded || this.loaded;
  }

  public async hasFeatureFlagAsync(featureFlag: typeof FeatureFlagService.ALL_FEATURES[number], forceReload: boolean = false): Promise<boolean> {
    await this.reloadIfNeeded(forceReload);
    return this.featureFlags.includes(featureFlag);
  }

  public hasFeatureFlag(featureFlag: typeof FeatureFlagService.ALL_FEATURES[number]): boolean {
    return this.featureFlags.includes(featureFlag);
  }
}
